import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import { removeHtmlTags } from '@common/modules/utils/string';

@Directive({
  selector: '[appHighlightText]',
  standalone: false
})
export class HighlightDirective {
  @Input('content')
  set content(content: string) {
    this._content = content;
  }
  get content(): string {
    return this._content;
  }

  @Input('searchTerm')
  set searchTerm(searchTerm: string) {
    this._searchTerm = searchTerm;
    this.highlight();
  }

  get searchTerm(): string {
    return this._searchTerm;
  }

  @Input() public caseSensitive: boolean;

  private _content: string;
  private _searchTerm: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.caseSensitive = false;
  }

  private highlight() {
    const nativeEl: HTMLElement = this.el.nativeElement;
    nativeEl.textContent = '';

    // Strip HTML tags from content to prevent XSS (defense-in-depth)
    const sanitizedContent = this._content ? removeHtmlTags(this._content) : '';

    if (this._searchTerm !== undefined && this._searchTerm != null && this._searchTerm.length > 0 && this._searchTerm[0] !== '.') {
      const splitFlag = this.caseSensitive ? '' : 'i';
      const matchFlag = this.caseSensitive ? 'g' : 'gi';
      const escapedSearchTerm = this._searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const searchPattern = new RegExp(escapedSearchTerm, splitFlag);
      const matchPattern = new RegExp(escapedSearchTerm, matchFlag);

      const separatedText = sanitizedContent.split(searchPattern);
      const separatedSearchedText = sanitizedContent.match(matchPattern);

      if (separatedSearchedText != null && separatedSearchedText.length > 0) {
        // Build DOM nodes safely instead of using innerHTML
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < separatedText.length; i++) {
          if (separatedText[i]) {
            fragment.appendChild(document.createTextNode(separatedText[i]));
          }
          if (i <= separatedSearchedText.length - 1) {
            const span = this.renderer.createElement('span');
            this.renderer.addClass(span, 'highlight');
            span.textContent = separatedSearchedText[i];
            fragment.appendChild(span);
          }
        }

        this.renderer.appendChild(nativeEl, fragment);
      } else {
        nativeEl.textContent = sanitizedContent;
      }
    } else {
      nativeEl.textContent = sanitizedContent;
    }
  }
}
